import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useIdleTimeout } from '../hooks/useIdleTimeout';
import toast from 'react-hot-toast';

export const IdleTimeoutController: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();

  const isEnabled = isAuthenticated && user?.rol_usr !== 'VENDEDORA_EN_LINEA';

  const handleIdle = async () => {
    if (isEnabled) {
      toast('Sesión cerrada por inactividad', { icon: '🔒' });
      await logout();
      window.location.href = '/login'; // Opcional, forzar recarga
    }
  };

  useIdleTimeout(
    handleIdle,
    5 * 60 * 1000, // 5 minutos
    isEnabled
  );

  return null;
};
